
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Switch',
  props: {
    checked: {
      type: Boolean
    },
    label: {
      type: String,
      default: ''
    }
  },
  emits: ['update:checked'],
  methods: {
    handleLabelClick ({ target }: any) {
      target.previousSibling.checked = !target.previousSibling.checked;
      this.$emit('update:checked', target.previousSibling.checked);
    }
  }
});
